// @flow

import { WelcomeMessage } from './WelcomeMessage'

export const GrowthTool = WelcomeMessage
